(function($) {
    'use strict';

    $.fn.newsList = function () {
        var $wrapper = $(this);
        var $newsList = $wrapper.find('.js-news-list');

        var ajaxUrl = $wrapper.data('url');
        var emptyText = $wrapper.data('empty');
        var moreText = $wrapper.data('more');

        var $loader = $('<div>', {
            class: 'loader',
            append: [
                $('<div>', {class: 'circle'}),
                $('<div>', {class: 'circle'}),
                $('<div>', {class: 'circle'}),
                $('<div>', {class: 'circle'}),
                $('<div>', {class: 'circle'}),
                $('<div>', {class: 'circle'}),
                $('<div>', {class: 'circle'}),
                $('<div>', {class: 'circle'})
            ]
        });

        var $loadMoreBtn = $('<button>', {
            class: 'js-load-more-btn load-more-btn',
            type: 'button',
            text: moreText,
            on: {
                'click': function () {
                    var pageCount = $wrapper.data('pageCount');
                    var currentPage = $wrapper.data('currentPage');
                    if (currentPage < pageCount) {
                        loadNews(currentPage + 1);
                    }
                }
            }
        });

        /**
         * Загрузить новости для N-ной страницы списка
         * @param {number} [page] - номер страницы списка новостей
         */
        var loadNews = function(page) {
            page = page || 1;

            $loadMoreBtn.detach();
            $loader.appendTo($wrapper);

            $.ajax({
                url: ajaxUrl,
                data: {
                    'page': page
                }
            }).done(function (data) {
                setTimeout(function () {
                    if (data.totalCount) {
                        // если есть новости

                        $wrapper.data({
                            currentPage: data.currentPage,
                            pageCount: data.pageCount
                        });
                        $newsList.append(data.html);
                        $loader.detach();
                        if (data.currentPage < data.pageCount) {
                            if ($wrapper.find('.js-load-more-btn').length === 0) {
                                $loadMoreBtn.appendTo($wrapper);
                            }
                        } else {
                            $loadMoreBtn.detach();
                        }
                    } else {
                        // если нет новостей

                        $wrapper.append($('<p>', {
                            text: emptyText
                        }));
                        $loader.detach();
                        $loadMoreBtn.detach();
                    }
                }, 100);
            }).fail(function () {
                // console.log('Не удалось загрузить новости');
            });
        };

        /**
         * Инициализация
         */
        var init = function () {
            loadNews();
        };

        init();
    };
})(jQuery);
